__turbopack_context__.v({
  "container": "ForgottenPasswordSlidingModal-module__bLiqnW__container",
  "errorIntro": "ForgottenPasswordSlidingModal-module__bLiqnW__errorIntro",
  "formContainer": "ForgottenPasswordSlidingModal-module__bLiqnW__formContainer",
  "heading": "ForgottenPasswordSlidingModal-module__bLiqnW__heading",
  "sideBySide": "ForgottenPasswordSlidingModal-module__bLiqnW__sideBySide",
});
